<template>
  <el-card>
    <div slot="header">
      <h1>订单导出</h1>
    </div>
    <div class="form-container">
      <el-form v-loading="loading" ref="form" :model="form" label-width="140px">
        <el-form-item label="内购活动">
          <el-select v-model="form.activityId" clearable placeholder="请选择" filterable>
            <el-option
              v-for="item in activities"
              :key="item.id"
              :label="item.activityName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-for="statusField in statusFields" :label="statusField.label">
          <el-select v-model="form[statusField.field]" clearable placeholder="请选择">
            <el-option
              v-for="item in $enums[statusField.field].getList()"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
       <el-form-item label="下单人">
          <el-input v-model="form.account" placeholder="下单人" />
        </el-form-item>
        <el-form-item v-for="timeRangeField in timeRangeFields" :label="timeRangeField.label">
          <el-date-picker
            v-model="form[timeRangeField.field]"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="buttons">
          <el-button type="primary" @click="submitForm">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import moment from 'moment'
const FileDownload = require('js-file-download');
const { mapGetters: mapActivitiesGetters } = createNamespacedHelpers('activities')

export default {
  components: {  },
  data() {
    return {
      loading: false,
      form: {
        activityId: undefined,
        createdAt: [],
        payTime: [],
        orderStatus: undefined,
        payStatus: undefined,
        shippingStatus: undefined,
        account: undefined,
      },
      statusFields: [
        {
          label: '订单状态',
          field: 'orderStatus'
        },
        {
          label: '支付状态',
          field: 'payStatus'
        },
        {
          label: '发货状态',
          field: 'shippingStatus'
        }
      ],
      timeRangeFields: [
        {
          label: '下单时间',
          field: 'createdAt'
        },
        {
          label: '付款时间',
          field: 'payTime'
        }
      ]
    }
  },
  computed: {
    ...mapActivitiesGetters({ activities: 'collection' })
  },
  methods: {
    async submitForm() {
      this.loading = true

      const query = {
        ...this.form,
        createdAt: this.$queryHelper.formatDateRange(this.form.createdAt),
        payTime: this.$queryHelper.formatDateRange(this.form.payTime),
      }

      try {
        const data = await this.$store.dispatch('report/orderReport', query)
        FileDownload(data, 'order-report.xlsx')
      } finally {
        this.loading = false
      }
      this.$message.success('订单报表导出成功')
    }
  },
  async mounted() {
    this.$store.dispatch('activities/collection', { all: true })
  }
}
</script>

<style scoped>

</style>
